import { useEffect } from "react";
import { useMap } from "react-leaflet/hooks";

/**
 * Component responsible for updating map view when coordinates change.
 * Synchronizes map position with selected location or user position.
 * @param {Object} coords - Target coordinates {lat, lng}
 * @param {Function} updateMap - Callback to update map position
 */
const MapUpdater = ({ coords, updateMap }) => {

  const map = useMap();

  useEffect(() => {

    if (coords && coords.lat && coords.lng && map) {
      // Guard: Ensure map container is ready
      try {
        const container = map.getContainer();
        if (!container) {
          console.warn("MapUpdater - Map container not ready, skipping update");
          return;
        }
        const zoom = map.getZoom();

        updateMap(map, coords, zoom);
      } catch (err) {
        console.error("MapUpdater - Error updating map:", err);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coords.lat, coords.lng, map, updateMap]);

  return null;
};

export default MapUpdater;
